module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.templateTypeText,
      "visible": _vm.editVisible,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "close-on-click-modal": false,
      "before-close": _vm.saveAlert,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isDialogLoading),
      expression: "isDialogLoading"
    }]
  }, _vm._l((_vm.questions), function(questionGroup, index) {
    return _c('el-card', {
      key: index,
      staticClass: "mb-20"
    }, [_vm._l((questionGroup), function(question) {
      return [_c('el-row', [_c('el-col', [_c('el-tooltip', {
        staticClass: "mb-2 mt-5",
        attrs: {
          "effect": "dark",
          "placement": "bottom",
          "disabled": question.guidance == ''
        }
      }, [_c('div', {
        staticStyle: {
          "max-width": "1000px"
        },
        attrs: {
          "slot": "content"
        },
        domProps: {
          "innerHTML": _vm._s(question.guidance)
        },
        slot: "content"
      }), _vm._v(" "), _c('h4', {
        staticClass: "question-title",
        style: (question.highlighted ? 'background:yellow;' : ''),
        attrs: {
          "id": 'question' + question.id
        }
      }, [_vm._v("\n                                    " + _vm._s(question.title))])])], 1)], 1), _vm._v(" "), (question == 'table') ? [_c('el-row', [_c('el-col', [_c('el-table', {
        attrs: {
          "data": question.config.list
        }
      }, _vm._l((question.config.title), function(cell, index) {
        return _c('el-table-column', {
          key: index,
          attrs: {
            "label": cell.key
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-input', {
                attrs: {
                  "type": "textarea",
                  "maxlength": _vm.maxLength
                },
                on: {
                  "change": _vm.checkQuestionInput
                },
                model: {
                  value: (scope.row[cell.value]),
                  callback: function($$v) {
                    _vm.$set(scope.row, cell.value, $$v)
                  },
                  expression: "scope.row[cell.value]"
                }
              })]
            }
          }], null, true)
        })
      }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _vm._l((question.config.list), function(row) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((row), function(col, index) {
          return [(col.type == 'input' || col.type == 'link') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            ref: "col",
            refInFor: true,
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "maxlength": _vm.maxLength,
              "type": "textarea",
              "rows": col.rows,
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'text') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24),
              "disabled": true
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "maxlength": _vm.maxLength,
              "type": "text",
              "rows": col.rows,
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'datetime') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('p', {
            staticClass: "gary  mt-5"
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "picker-options": _vm.datePickerOptions.option1,
              "type": "date",
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.date),
              callback: function($$v) {
                _vm.$set(col, "date", $$v)
              },
              expression: "col.date"
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "gary mt-5"
          }, [_vm._v(_vm._s(col.timeDescription))]), _vm._v(" "), _c('el-time-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select time',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.time),
              callback: function($$v) {
                _vm.$set(col, "time", $$v)
              },
              expression: "col.time"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'date') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            }
          }, [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "picker-options": _vm.datePickerOptions.option1,
              "type": "date",
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'checkbox') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-checkbox-group', {
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          }, [(col.vertical) ? _vm._l((col.list), function(cb, index) {
            return _c('p', {
              key: index
            }, [_c('el-checkbox', {
              attrs: {
                "label": cb
              }
            })], 1)
          }) : _vm._l((col.list), function(cb, index) {
            return _c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "disabled": question.config.forTeacher
              }
            })
          })], 2)], 1)]) : _vm._e(), _vm._v(" "), (col.type == 'radio') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [(col.vertical) ? _vm._l((col.list), function(lb, index) {
            return _c('p', {
              key: index
            }, [_c('el-radio', {
              staticClass: "radio mb-5",
              attrs: {
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })], 1)
          }) : _vm._l((col.list), function(lb, index) {
            return _c('el-radio', {
              key: index,
              staticClass: "radio mb-5 mt-5",
              attrs: {
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })
          })], 2) : _vm._e(), _vm._v(" "), (col.type == 'image') ? _c('el-col', {
            staticClass: "mt-5",
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('el-upload', {
            attrs: {
              "action": _vm.uploadUrl,
              "data": _vm.uploadFormData,
              "file-list": _vm.clonedImageList,
              "list-type": "picture",
              "accept": "image/jpeg, image/png",
              "beforeUpload": _vm.handleBeforeImageUpload,
              "on-success": function a(response, file, fileList) {
                _vm.handleUploadImageSuccess(response, file, fileList, col.answer)
              },
              "on-change": _vm.handleFileChanged,
              "on-preview": _vm.handlePictureCardPreview,
              "on-error": _vm.handleUploadError,
              "on-remove": function b(file, fileList) {
                _vm.handleImageRemove(file, fileList, col.answer)
              },
              "disabled": _vm.imageCount >= 5 || _vm.isAuthorizing
            }
          }, [_c('el-button', {
            attrs: {
              "size": "small",
              "type": "primary",
              "icon": "el-icon-upload",
              "disabled": _vm.imageCount >= 5 || _vm.isAuthorizing,
              "loading": _vm.isAuthorizing
            }
          }, [_vm._v("Upload\n                                        ")]), _vm._v(" "), _c('div', {
            staticClass: "el-upload__tip",
            attrs: {
              "slot": "tip"
            },
            slot: "tip"
          }, [_vm._v("\n                                            " + _vm._s(_vm.imageCount >= 5 ? 'You can only upload up to 5 images, please choose the best fit ones.' : '1 to 5 images, only jpg/png allowed, less than 4MB') + "\n                                        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'pdf') ? _c('el-col', {
            staticClass: "mt-5",
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('el-upload', {
            attrs: {
              "action": _vm.uploadUrl,
              "data": _vm.uploadFormData,
              "file-list": _vm.clonedPDFList,
              "accept": "application/pdf",
              "beforeUpload": _vm.handleBeforePDFUpload,
              "on-success": function a(response, file, fileList) {
                _vm.handleUploadPDFSuccess(response, file, fileList, col.answer)
              },
              "on-change": _vm.handleFileChanged,
              "on-preview": _vm.handlePDFPreview,
              "on-error": _vm.handleUploadError,
              "on-remove": function b(file, fileList) {
                _vm.handlePDFRemove(file, fileList, col.answer)
              },
              "disabled": _vm.isUploading
            }
          }, [_c('el-button', {
            attrs: {
              "size": "small",
              "type": "primary",
              "icon": "el-icon-upload",
              "disabled": _vm.isUploading
            }
          }, [_vm._v("Upload")]), _vm._v(" "), _c('div', {
            staticClass: "el-upload__tip",
            attrs: {
              "slot": "tip"
            },
            slot: "tip"
          }, [_vm._v("only pdf allowed, less than 10MB")])], 1)], 1) : _vm._e()]
        })], 2)]
      }), _vm._v(" "), _c('el-row', [(question.config.more) ? _c('el-col', {
        staticClass: "mt-5",
        attrs: {
          "span": 5
        }
      }, [_c('el-button-group', [_c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "danger",
          "size": "mini",
          "icon": "el-icon-plus"
        },
        on: {
          "click": function($event) {
            return _vm.more(question.config.list)
          }
        }
      }), _vm._v(" "), _c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "success",
          "size": "mini",
          "icon": "el-icon-minus"
        },
        on: {
          "click": function($event) {
            return _vm.less(question.config.list)
          }
        }
      })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.role == 'student' || _vm.role == 'ta') ? _c('el-row', [(question.commentList && question.commentList.length != 0) ? _c('el-col', {
        staticClass: "p-10 bg-lightgarg mt-5",
        attrs: {
          "span": 24
        }
      }, [(question.showCommentCount == 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = question.commentList.length
          }
        }
      }, [_vm._v("\n                                View " + _vm._s(question.commentList.length - _vm.showCommentCount) + " more comments\n                            ")]) : _vm._e(), _vm._v(" "), (question.showCommentCount != 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = 3
          }
        }
      }, [_vm._v("Hide more\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((question.commentList), function(comment, commentIndex) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (commentIndex > question.commentList.length - question.showCommentCount - 1),
            expression: "commentIndex > question.commentList.length-question.showCommentCount-1"
          }],
          key: commentIndex
        }, [_c('div', {
          staticClass: "commentContent dark mt-5 pb-0",
          style: (comment.highlighted ? 'background:yellow;' : ''),
          attrs: {
            "id": 'comment' + comment.id
          }
        }, [_c('span', {
          staticClass: "success"
        }, [_c('b', [_vm._v(_vm._s(comment.fromName))])]), _c('span', [_vm._v(" : " + _vm._s(comment.content))])]), _vm._v(" "), _c('div', {
          staticClass: "gary mb-2"
        }, [_vm._v(_vm._s(comment.time) + "\n                                        "), (comment.userId == _vm.currentCommentatorId) ? _c('el-button', {
          staticClass: "ml-5",
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.cancelComment(comment, question.commentList)
            }
          }
        }, [_vm._v("\n                                            remove\n                                        ")]) : _vm._e()], 1)])
      }), 0)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.role == 'student' || _vm.role == 'ta') ? _c('el-row', {
        staticClass: "mb-10 mt-5"
      }, [_c('el-col', {
        attrs: {
          "span": 1
        }
      }, [(!question.config.forTeacher) ? _c('el-button', {
        attrs: {
          "type": "success",
          "size": "mini"
        },
        on: {
          "click": function($event) {
            question.show = !question.show
          }
        }
      }, [_vm._v("\n                                " + _vm._s(question.show ? '    Hide     ' : 'Comment') + "\n                            ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.show),
          expression: "question.show"
        }, {
          name: "loading",
          rawName: "v-loading",
          value: (question.isSavingComment),
          expression: "question.isSavingComment"
        }],
        staticClass: "mb-10"
      }, [_c('el-col', {
        attrs: {
          "span": 20
        }
      }, [_c('el-input', {
        staticClass: "post-textarea",
        attrs: {
          "type": "textarea",
          "autofocus": "",
          "rows": 3,
          "resize": "none",
          "placeholder": "Press Ctrl + Enter to post"
        },
        on: {
          "change": _vm.checkEmoji
        },
        nativeOn: {
          "keyup": function($event) {
            return _vm.pressAction(question, question.commentList, $event)
          }
        },
        model: {
          value: (question.content),
          callback: function($$v) {
            _vm.$set(question, "content", $$v)
          },
          expression: "question.content"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('el-button', {
        staticClass: "comment-submit p-30",
        attrs: {
          "type": "success",
          "size": "small",
          "disabled": !question.content
        },
        on: {
          "click": function($event) {
            return _vm.saveComment(question, question.commentList)
          }
        }
      }, [_vm._v("Post\n                            ")])], 1)], 1)]
    })], 2)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveAlert(function() {
          _vm.editVisible = false
        })
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": _vm.isUploading || _vm.isDialogLoading
    },
    on: {
      "click": _vm.saveAnswer
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.picReview,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "title": "Preview",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.picReview = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    ref: "pdfPreview",
    attrs: {
      "target": "_blank"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b85e906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/EvidenceDialog.vue
// module id = 604
// module chunks = 1